import React from 'react'
import PlatformInsights from '../components/PlatformInsights'
import ServiceStatsCards from '../components/ServiceStatsCards'
import BlogSection from '../components/BlogSection'
import CheckCategories from '../components/CheckCategories'
import WhyChooseUs from '../components/WhyChooseUs'
import ExperienceSection from '../components/ExperienceSection'
import TechnologyPartnersSection from '../components/TechnologyPartnersSection'

const BackgroundChecksPage = () => {
  return (
   <>
    <PlatformInsights/>
    <ServiceStatsCards/>
    <WhyChooseUs/>
    <ExperienceSection/>
    <CheckCategories/>
    <TechnologyPartnersSection/>
    <BlogSection/>
   </>
  )
}

export default BackgroundChecksPage